import React, { useEffect, useState } from 'react';
import { Table, Button, Space, message, Input, Tag, Card, Typography } from 'antd';
import { PlusOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
 import { useHistory } from 'react-router-dom';
import { useConfig } from '../../contexts/ConfigContext';
import { useCompany } from '../../contexts/CompanyContext';
import { useTemplates } from '../../hooks/useManufacturing';
import useAuth from '../../hooks/useAuth';

const { Title } = Typography;

const ViewTemplatesList: React.FC = () => {
  const { config } = useConfig();
  const { company } = useCompany();
  const history = useHistory();
  const { tokenData } = useAuth.useToken('authCsrfToken', config.session, config.key);
  const [searchText, setSearchText] = useState('');

  const { data, isLoading, error } = useTemplates(tokenData, { company: company.current?.id });

  useEffect(() => {
    if (error) {
      message.error("Error al cargar las plantillas de producción");
    }
  }, [error]);

  const columns = [
    {
      title: 'Nombre de la Plantilla',
      dataIndex: 'name',
      key: 'name',
      width: 220,
      render: (val: string, record: any) => (
        <a 
          style={{ fontWeight: 600, fontSize: 13, color: '#1890ff' }}
          onClick={() => history.push(`/edit-template/${record.uid || record.id}`)}
        >
          {val}
        </a>
      )
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      width: 280,
      render: (val: string) => val || '-'
    },
    {
      title: 'Estado',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 110,
      align: 'center' as const,
      render: (active: boolean) => <Tag color={active ? 'green' : 'default'}>{active ? 'Activo' : 'Inactivo'}</Tag>
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 120,
      align: 'center' as const,
      render: (_: any, record: any) => (
        <Button 
          type="primary" 
          ghost 
          size="small"
          icon={<EditOutlined />} 
          onClick={() => history.push(`/edit-template/${record.uid || record.id}`)}
        >
          Editar
        </Button>
      ),
    },
  ];

  const filteredData = data?.templates?.filter((template: any) => 
    template.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    template.description?.toLowerCase().includes(searchText.toLowerCase())
  ) || [];

  return (
    <div style={{ padding: config.isMobile ? '4px 0' : '0' }}>
      <Card bodyStyle={{ padding: config.isMobile ? '14px 10px' : '24px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          flexWrap: 'wrap', 
          gap: '12px',
          marginBottom: '16px' 
        }}>
          <Title level={config.isMobile ? 4 : 3} style={{ margin: 0 }}>
            Plantillas de Producción (Recetas)
          </Title>
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            style={{ width: config.isMobile ? '100%' : 'auto', height: config.isMobile ? '38px' : 'auto' }}
            onClick={() => history.push('/create-template')}
          >
            Crear Plantilla
          </Button>
        </div>
        
        <div style={{ marginBottom: '16px', maxWidth: config.isMobile ? '100%' : '380px' }}>
          <Input 
            placeholder="Buscar plantilla..." 
            prefix={<SearchOutlined />} 
            allowClear
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
          />
        </div>

        <Table 
          columns={columns} 
          dataSource={filteredData} 
          rowKey="id" 
          loading={isLoading}
          size={config.isMobile ? 'small' : 'middle'}
          scroll={{ x: 700 }}
          pagination={{ 
            showSizeChanger: true, 
            defaultPageSize: 10, 
            pageSizeOptions: ['10', '20', '50'],
            size: config.isMobile ? 'small' : 'default'
          }}
        />
      </Card>
    </div>
  );
};

export default ViewTemplatesList;